import { render, staticRenderFns } from "./QaManagement.vue?vue&type=template&id=d3cc37a6&"
import script from "./QaManagement.vue?vue&type=script&lang=ts&"
export * from "./QaManagement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports